import './style-loading-page.css';

export default function LoadingPage(): JSX.Element {
  return (
    <div className='loading-page'>
      <p className='text'>Loading ...</p>
    </div>
  );
}
